import { Component, OnInit, OnDestroy } from '@angular/core';
import { Globals } from '../../globals';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    public ng = { title: '', link: '', data: [] };
    public kn = { title: '', link: '', data: [] };
    public cs = { title: '', link: '', data: [] };
    public cn = { title: '', link: '', data: [] };
    public width: number;
    public data = [];
    public slide = [];
    public content: number = 1;
    public contents: number = 4;
    public news = [];
    public about = [];
    public fecback = [];
    public library = { data: [], listImages: [], listVideo: [] };
    public connect;
    public newsmobi: any;
    public token: any = {
        getslide: "api/getListSlide",
        getlibrarylimit: "api/getLibraryLimitByType",
        getContent: "api/getlistHomecontent",
        getProductType: "api/getlistproductOtion",
        getlibrary: "api/getLibrary",
        getContentByGroupLimit: "api/getContentByGroupLimit",
    }
    constructor(public globals: Globals, public sanitizer: DomSanitizer) {

        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "getlistproductOtion":
                    this.data = res.data;
                    break;
                case "getListSlide":
                    this.slide = res.data;
                    break;
                case "getlistHomecontent":
                    this.news = res.data;
                    this.newsmobi = res.data.filter((res: any) => res.id != this.news[0]['id']);

                    break;
                case "getlibraryvideolimit":
                    this.library.listVideo = res.data;
                    this.library.listVideo.reduce((n, o, i) => {
                        o.value = (o.type == 2) ? this.sanitizer.bypassSecurityTrustResourceUrl(o.value.replace('watch?v=', 'embed/')) : o.value;
                        return n;
                    }, []);
                    break;

                case "getlibraryimagelimit":
                    this.library.listImages = res.data;
                    break;
                case "getcontentbygrouplimit":
                    let datacontent = res.data;
                    this.ng.title = datacontent[9][0]['namegroup'];
                    this.ng.link = datacontent[9][0]['linkgroup'];
                    this.ng.data = datacontent[9];
                    this.cs.title = datacontent[11][0]['namegroup'];
                    this.cs.link = datacontent[11][0]['linkgroup'];
                    this.cs.data = datacontent[11];
                    this.kn.title = datacontent[12][0]['namegroup'];
                    this.kn.link = datacontent[12][0]['linkgroup'];
                    this.kn.data = datacontent[12];
                    this.cn.title = datacontent[13][0]['namegroup'];
                    this.cn.link = datacontent[13][0]['linkgroup'];
                    this.cn.data = datacontent[13];
                    break;
                default:
                    break;
            }
        });
        this.width = document.body.getBoundingClientRect().width
        setTimeout(() => {

            if (window["slides"]) {
                window["slides"]();
                window["tabs"]();
                window["slidesProduct"]();
                window["slidesContent"]();
                window["feedback"]();

            }
        }, 1000);
    }

    ngOnInit() {
        this.getslide();
        this.getProduct();
        this.getContent();
        this.getContentByGroupLimit();
        this.globals.send({ path: this.token.getlibrarylimit, token: "getlibraryvideolimit", params: { type: 2, limit: 2 } });
        this.globals.send({ path: this.token.getlibrarylimit, token: "getlibraryimagelimit", params: { type: 1, limit: 7 } });
    }
    ngOnDestroy() {
        this.connect.unsubscribe();
    }
    getProduct() {
        this.globals.send({ path: this.token.getProductType, token: 'getlistproductOtion', params: { type: 2 } });
    }
    getContent() {
        this.globals.send({ path: this.token.getContent, token: "getlistHomecontent" });
    }
    getslide() {
        this.globals.send({ path: this.token.getslide, token: "getListSlide" });
    }
    getContentByGroupLimit() {
        this.globals.send({ path: this.token.getContentByGroupLimit, token: "getcontentbygrouplimit" });
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/home/home.component.ts